import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import CardWrapper from "../CardWrapper";
import {
  getCnvCGenes,
  getCnvGeneClassification,
} from "../../../state/selectors/CardsUI.selectors";
import Card from "../Card";
import { getPathogenicityColorByAllNames } from "../../../common/helpers/Constant";

const { instanceOf, shape, number } = PropTypes;

const CNVDetailsCard = ({ card, cnvGenes, cnvGenesClassification }) => {
  const { codingGenesLength, allGenes } = cnvGenes;
  return (
    <CardWrapper
      {...card}
      color={
        getPathogenicityColorByAllNames(cnvGenesClassification) || card.color
      }
    >
      <div>
        <span className="tw-pr-1 tw-font-normal">Coding genes:</span>
        {allGenes > 0 ? `${codingGenesLength} / ${allGenes}` : 0}
      </div>
    </CardWrapper>
  );
};

CNVDetailsCard.propTypes = {
  card: instanceOf(Card).isRequired,
  cnvGenes: shape({
    codingGenesLength: number,
    allGenes: number,
  }),
  cnvGenesClassification: PropTypes.string,
};

CNVDetailsCard.defaultProps = {
  cnvGenes: null,
  cnvGenesClassification: "",
};

const mapStateToProps = (state) => ({
  cnvGenes: getCnvCGenes(state),
  cnvGenesClassification: getCnvGeneClassification(state),
});

export default connect(mapStateToProps)(CNVDetailsCard);
